export const MeetingSheduledIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4340_988)">
        <path
          d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
          fill="white"
        />
        <path
          d="M10.3898 14.3117L7.8611 11.824L7 12.6652L10.3898 16L17.6667 8.84116L16.8116 8L10.3898 14.3117Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4340_988">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
